<template>
    <div class="componentRoot" style="width: 100vw; overflow: hidden;">
        <v-container tag="header" fluid class="py-0">
            <v-row>
                <v-col style="position: relative">
                    <img alt="Symbolbild zur Atemarbeit" fetchpriority="high" loading="eager" decoding="async" src="/images/pages/Breathwork_Cass_empty-1920-1af95391.webp"
                        srcset="/images/pages/Breathwork_Cass_empty-640-1a3e503b.webp 640w, /images/pages/Breathwork_Cass_empty-960-2615d27e.webp 960w, /images/pages/Breathwork_Cass_empty-1600-63ace6c8.webp 1600w, /images/pages/Breathwork_Cass_empty-1920-1af95391.webp 1920w"
                        sizes="100vw" :style="{
                        height: imageHeight
                    }" style="
                        object-fit: cover; 
                        width: 100%;
                        object-position: top;" />

                    <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
                        :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
                        <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
                        <h1 style="color: white" class="mb-4" v-html="$t('titleScreens.atmen')"></h1>
                        <v-btn href="/kontakt#contactFormId" flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
                            }}</v-btn><br>
                        <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
                        }}</small>
                    </div>
                </v-col>
            </v-row>


            <WaveVue aria-hidden="true" :color="'rgb(var(--v-theme-background))'" :negative="true"
                :style="{ 'margin-top': isMobile ? '-49px' : '-138px' }" :height="isMobile ? 30 : 120"
                style="z-index: 2; position: relative;" />

        </v-container>
        <v-container :fluid="$vuetify.display && $vuetify.display.width < 1920" style="max-width: 1920px">
            <v-row tag="nav" class="mt-16" :style="{ 'margin-bottom': isMobile ? '50px' : '50px' }">
                <v-col class="flex-col inactivePoint" style="align-items: center">
                    <a href="/staunendlernen" class="flex-col"
                        style="text-decoration: none !important; color: rgb(var(--v-theme-on-background)); cursor: pointer; align-items: center;">
                        <img alt="Staunend lernen" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                            src="/images/icons/01_staunend_lernen_4c.svg" />
                        <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Staunend lernen</p>
                    </a>
                </v-col>
                <v-col class="flex-col inactivePoint" style="align-items: center;">
                    <a href="/eigenewege" class="flex-col"
                        style="text-decoration: none !important; color: rgb(var(--v-theme-on-background)); cursor: pointer; align-items: center;">
                        <img alt="Eigene Wege finden" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                            src="/images/icons/02_eigene_wege_finden_4c.svg" />
                        <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Eigene Wege finden</p>
                    </a>
                </v-col>
                <v-col class="flex-col" style="align-items: center">
                    <a href="/breathwork" aria-current="true" class="flex-col"
                        style="text-decoration: none !important; color: rgb(var(--v-theme-on-background)); cursor: pointer; align-items: center;">
                        <img alt="Freiheit atmen" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                            src="/images/icons/03_freiheit_atmen_4c.svg" />
                        <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Freiheit Atmen</p>
                    </a>
                </v-col>
                <v-col class="flex-col inactivePointNoHover" style="align-items: center">
                    <img alt="Lebendig wachsen" loading="lazy" decoding="async" :style="{ height: 'calc(100vw/' + QuadWidth + ')' }" cover
                        src="/images/icons/04_lebendig_wachsen_4c.svg" />
                    <p class="seo-heading-display" :class="{ 'seo-sr-only': isMobile }">Lebendig wachsen</p>
                </v-col>
            </v-row>
            <v-row tag="nav" class="mt-16" style="margin-bottom: 134px">
                <v-spacer></v-spacer>
                <v-col :cols="twoCols" class="pa-8 mr-8 flex-col" tag="a" href="/breathwork" :class="{ 'mb-6': isMobile }"
                    style="text-decoration: none; background-color: rgb(var(--v-theme-light)); border-radius: 15px; align-items: center; cursor: pointer;">
                    <p style="color: rgb(var(--v-theme-on-background))" v-html="$t('titleScreens.breathwork')" class="seo-heading-display"></p>
                </v-col>
                <v-col :cols="twoCols" class="pa-8 ml-8 flex-col"
                    style="background-color: rgb(var(--v-theme-primary)); border-radius: 15px;  align-items: center; cursor: pointer;" aria-current="page">
                    <p style="color: rgb(var(--v-theme-light))" v-html="$t('titleScreens.atmen')" class="seo-heading-display"></p>
                </v-col>
                <v-spacer></v-spacer>
            </v-row>


            <v-row tag="section" aria-labelledby="atmen-sec1-title" v-if="!isMobile" class="wave-mask mx-0"
                style="margin-top: -70px; z-index: 2 !important; position: relative;" :style="{
                    'flex-direction': isMobile ? 'column-reverse' : 'row'
                }">
                <v-spacer v-if="!isXS" />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 id="atmen-sec1-title" class="seo-heading-display mb-4">{{ $t("atmen.sec1.title") }}</h2>
                    <div v-html="$t('atmen.sec1.text')"></div>
                </v-col>
                <v-spacer v-if="!isXS" />
                <v-col :cols="imageCols" class="pa-0">
                    <v-img alt="Foto mit Eva Kaczor" style="height: 100%" cover src="/images/pages/Foto-mit-Eva-Kazcor-1600-4c69f621.webp"
                        srcset="/images/pages/Foto-mit-Eva-Kazcor-640-c43ce6a9.webp 640w, /images/pages/Foto-mit-Eva-Kazcor-960-5d54aa89.webp 960w, /images/pages/Foto-mit-Eva-Kazcor-1600-4c69f621.webp 1600w, /images/pages/Foto-mit-Eva-Kazcor-1920-b042edcf.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                </v-col>
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img alt="Foto mit Eva Kaczor" style="height: 100%" cover src="/images/pages/Foto-mit-Eva-Kazcor-1600-4c69f621.webp"
                        srcset="/images/pages/Foto-mit-Eva-Kazcor-640-c43ce6a9.webp 640w, /images/pages/Foto-mit-Eva-Kazcor-960-5d54aa89.webp 960w, /images/pages/Foto-mit-Eva-Kazcor-1600-4c69f621.webp 1600w, /images/pages/Foto-mit-Eva-Kazcor-1920-b042edcf.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                    </v-col>
                </v-row>
                <v-row tag="section" aria-labelledby="atmen-sec1-title" class="wave-mask pb-16 px-8">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 id="atmen-sec1-title" class="seo-heading-display mb-4">{{ $t("atmen.sec1.title") }}</h2>
                        <div v-html="$t('atmen.sec1.text')"></div>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row tag="section" aria-labelledby="atmen-sec2-title" v-if="!isMobile" class="wave-mask mx-0">
                <v-col :cols="imageCols" class="pa-0">
                    <v-img alt="PSYCHEDELIC BREATH® Session" style="height: 100%" cover src="/images/pages/Psychedelic-Breathwork-Session-1600-e1c4a0b6.webp"
                        srcset="/images/pages/Psychedelic-Breathwork-Session-640-11ec5d51.webp 640w, /images/pages/Psychedelic-Breathwork-Session-960-df8c9661.webp 960w, /images/pages/Psychedelic-Breathwork-Session-1600-e1c4a0b6.webp 1600w, /images/pages/Psychedelic-Breathwork-Session-1920-fc9d196d.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                </v-col>
                <v-spacer v-if="!isXS" />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 id="atmen-sec2-title" class="seo-heading-display mb-4">{{ $t("atmen.sec2.title") }}</h2>
                    <div v-html="$t('atmen.sec2.text')"></div>
                </v-col>
                <v-spacer v-if="!isXS" />
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img alt="PSYCHEDELIC BREATH® Session" style="height: 100%" cover src="/images/pages/Psychedelic-Breathwork-Session-1600-e1c4a0b6.webp"
                        srcset="/images/pages/Psychedelic-Breathwork-Session-640-11ec5d51.webp 640w, /images/pages/Psychedelic-Breathwork-Session-960-df8c9661.webp 960w, /images/pages/Psychedelic-Breathwork-Session-1600-e1c4a0b6.webp 1600w, /images/pages/Psychedelic-Breathwork-Session-1920-fc9d196d.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                    </v-col>
                </v-row>
                <v-row tag="section" aria-labelledby="atmen-sec2-title" class="wave-mask pb-16 px-8">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 id="atmen-sec2-title" class="seo-heading-display mb-4">{{ $t("atmen.sec2.title") }}</h2>
                        <div v-html="$t('atmen.sec2.text')"></div>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>

            <v-row tag="section" aria-labelledby="atmen-sec3-title" v-if="!isMobile" class="wave-mask mx-0"
                style="margin-top: -70px; z-index: 2 !important; position: relative;" :style="{
                    'flex-direction': isMobile ? 'column-reverse' : 'row'
                }">
                <v-spacer v-if="!isXS" />
                <v-col :cols="textCols"
                    style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                    <h2 id="atmen-sec3-title" class="seo-heading-display mb-4">{{ $t("atmen.sec3.title") }}</h2>
                    <div v-html="$t('atmen.sec3.text')"></div>
                </v-col>
                <v-spacer v-if="!isXS" />
                <v-col :cols="imageCols" class="pa-0">
                    <v-img alt="Atemarbeit und Meditation" style="height: 100%" cover src="/images/pages/Power-of-Breathwork-and-Meditation-II-1600-f392c5e7.webp"
                        srcset="/images/pages/Power-of-Breathwork-and-Meditation-II-640-fb4ba1ab.webp 640w, /images/pages/Power-of-Breathwork-and-Meditation-II-960-c85a7d9f.webp 960w, /images/pages/Power-of-Breathwork-and-Meditation-II-1600-f392c5e7.webp 1600w, /images/pages/Power-of-Breathwork-and-Meditation-II-1920-2e5a7f1f.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                </v-col>
            </v-row>
            <div v-else>
                <v-row class="mx-0 light-background wave-mask" :style="{ 'margin-top': isMobile ? '-29px' : '-110px' }">
                    <v-col :cols="imageCols" class="pa-0">
                        <v-img alt="Atemarbeit und Meditation" style="height: 100%" cover
                            src="/images/pages/Power-of-Breathwork-and-Meditation-II-1600-f392c5e7.webp"
                        srcset="/images/pages/Power-of-Breathwork-and-Meditation-II-640-fb4ba1ab.webp 640w, /images/pages/Power-of-Breathwork-and-Meditation-II-960-c85a7d9f.webp 960w, /images/pages/Power-of-Breathwork-and-Meditation-II-1600-f392c5e7.webp 1600w, /images/pages/Power-of-Breathwork-and-Meditation-II-1920-2e5a7f1f.webp 1920w"
                        sizes="(max-width: 959px) 100vw, 60vw" />
                    </v-col>
                </v-row>
                <v-row tag="section" aria-labelledby="atmen-sec3-title" class="wave-mask pb-16 px-8">
                    <v-spacer />
                    <v-col :cols="textCols"
                        style="padding: 110px 0; display: flex; justify-content: center; flex-direction: column;">
                        <h2 id="atmen-sec3-title" class="seo-heading-display mb-4">{{ $t("atmen.sec3.title") }}</h2>
                        <div v-html="$t('atmen.sec3.text')"></div>
                    </v-col>
                    <v-spacer />
                </v-row>
            </div>


            <!-- <WaveVue aria-hidden="true" :color="'rgb(var(--v-theme-primary))'" :negative="true" :style="{'margin-top': isMobile ? '-18px' : '-120px'}" :height="isMobile ? 20 : 120" style="z-index: 2; position: relative;" /> -->

            <v-row tag="section" aria-labelledby="atmen-safety-title" class="primary-background mx-0 wave-mask">
                <v-spacer />
                <v-col :cols="mainCols" style="padding: 110px 16px 150px">
                    <div v-html="$t('atmen.safety.headline')" style="color: rgb(var(--v-theme-light))"></div>
                    <h2 id="atmen-safety-title" class="seo-heading-display mb-4" style="color: rgb(var(--v-theme-light))">{{ $t("atmen.safety.title") }}</h2>
                    <div style="display: grid; gap: 15px" :style="{ 'grid-template-columns': isTooTight }">
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item1')"></div>
                        </div>
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item2')"></div>
                        </div>
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item3')"></div>
                        </div>
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item4')"></div>
                        </div>
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item5')"></div>
                        </div>
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item6')"></div>
                        </div>
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item7')"></div>
                        </div>
                        <div class="safety-grid-item">
                            <div v-html="$t('atmen.safety.grid-item8')"></div>
                        </div>
                    </div>
                    <div v-html="$t('atmen.safety.subline')" style="color: rgb(var(--v-theme-light)); margin-top: 25px;"></div>
                </v-col>
                <v-spacer />
            </v-row>


            <!-- <WaveVue aria-hidden="true" :color="'rgb(var(--v-theme-background))'" :negative="true" :style="{'margin-top': isMobile ? '-18px' : '-120px'}" :height="isMobile ? 20 : 120" style="z-index: 2; position: relative;" /> -->


            <v-row tag="section" aria-labelledby="atmen-sec4-title" class="mx-0 background-background wave-mask"
                style="margin-top: -70px; z-index: 2 !important; position: relative;" :style="{
                    'flex-direction': isMobile ? 'column-reverse' : 'row'
                }">
                <v-col :cols="imageCols" class="pa-8" :class="{ 'pb-16': isMobile }"
                    style="display: flex;align-items: center; justify-content: center;">
                    <img alt="Begleitbild zum Gespräch über Atemarbeit" loading="lazy" decoding="async" :style="{ height: smallImageHeight }" class="rounded-lg"
                        src="/images/pages/AdobeStock_801467717-734-5abb928c.webp"
                        srcset="/images/pages/AdobeStock_801467717-640-4ebbd4b4.webp 640w, /images/pages/AdobeStock_801467717-734-5abb928c.webp 734w"
                        sizes="(max-width: 600px) 250px, (max-width: 960px) 350px, 550px" style="aspect-ratio: 1; object-fit: cover;" />
                </v-col>
                <v-spacer />
                <v-col :cols="textCols" class="mb-8 px-8"
                    style=" display: flex; justify-content: center; flex-direction: column;"
                    :style="{ padding: isMobile ? '110px 16px 60px' : '200px 16px' }">
                    <h2 id="atmen-sec4-title" class="seo-heading-display mb-4">{{ $t("atmen.sec4.title") }}</h2>
                    <div v-html="$t('atmen.sec4.text')"></div>
                </v-col>
                <v-spacer />
            </v-row>


            <v-row tag="section" aria-labelledby="freiheitatmen-information-1" class="mx-0 seo-information-section"
                style="position: relative; border-radius: 15px;"
                :style="{ padding: isMobile ? '56px 8px' : '88px 16px' }">
                <v-spacer />
                <v-col cols="12" md="10" lg="8" xl="7" class="px-6 px-md-8">
                    <h2 id="freiheitatmen-information-1" class="seo-information-heading mb-6">{{ $t("seoContent.freiheitatmen.section1.title") }}</h2>
                    <p>{{ $t("seoContent.freiheitatmen.section1.paragraph1") }}</p>
                    <p>{{ $t("seoContent.freiheitatmen.section1.paragraph2") }}</p>
                </v-col>
                <v-spacer />
            </v-row>

            <v-row tag="section" aria-labelledby="freiheitatmen-information-2" class="mx-0 seo-information-section"
                style="position: relative; border-radius: 15px;"
                :style="{ padding: isMobile ? '56px 8px' : '88px 16px', backgroundColor: 'rgb(var(--v-theme-light))' }">
                <v-spacer />
                <v-col cols="12" md="10" lg="8" xl="7" class="px-6 px-md-8">
                    <h2 id="freiheitatmen-information-2" class="seo-information-heading mb-6">{{ $t("seoContent.freiheitatmen.section2.title") }}</h2>
                    <p>{{ $t("seoContent.freiheitatmen.section2.paragraph1") }}</p>
                    <p>{{ $t("seoContent.freiheitatmen.section2.paragraph2") }}</p>
                    <v-btn href="/kontakt#contactFormId" flat class="primaryButton mt-8 rounded-xl">{{ $t("landing.contactText2") }}</v-btn>
                </v-col>
                <v-spacer />
            </v-row>

        </v-container>
    </div>
</template>

<script>

export default {
    name: "freiheitAtmen",

    computed: {
        smallImageHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "250px"
                case "sm":
                    return "350px"
                case "md":
                    return "350px"
                case "lg":
                    return "550px"
                case "xl":
                    return "550px"
                case "xxl":
                    return "550px"
                default:
                    return "550px"
            }
        },
        leftAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        rightAboutMeCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "12";
                case "lg":
                    return "6";
                case "xl":
                    return "6";
                case "xxl":
                    return "6";
                default:
                    return "6";
            }
        },
        leftServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "8";
                case "lg":
                    return "8";
                case "xl":
                    return "8";
                case "xxl":
                    return "8";
                default:
                    return "8";
            }
        },
        rightServiceCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "12";
                case "sm":
                    return "12";
                case "md":
                    return "4";
                case "lg":
                    return "4";
                case "xl":
                    return "4";
                case "xxl":
                    return "4";
                default:
                    return "4";
            }
        },
        marginLeftOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "0px";
                case "sm":
                    return "0px";
                case "md":
                    return "50px";
                case "lg":
                    return "100px";
                case "xl":
                    return "50px";
                case "xxl":
                    return "50px";
                default:
                    return "50px";
            }
        },
        imageHeight() {
            let windowHeight = this.$vuetify.display.height
            let cutoffHeight = 500

            switch (this.$vuetify.display.name) {
                case "xs":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "sm":
                    return (windowHeight * 0.8 > cutoffHeight) ? "80vh" : (cutoffHeight + 'px');
                case "md":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "lg":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                case "xxl":
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
                default:
                    return (windowHeight * 0.7 > cutoffHeight) ? "70vh" : (cutoffHeight + 'px');
            }
        },
        maxBannerWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "90vw";
                case "sm":
                    return "90%";
                case "md":
                    return "90%";
                case "lg":
                    return "80%";
                case "xl":
                    return "80%";
                case "xxl":
                    return "60%"
                default:
                    return "60%"
            }
        },
        bannerOffset() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "10%";
                case "sm":
                    return "10%";
                case "md":
                    return "10%";
                case "lg":
                    return "10%";
                case "xl":
                    return "10%";
                case "xxl":
                    return "15%"
                default:
                    return "15%"
            }
        },
        spacerHeight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return "100px";
                case "sm":
                    return "100px";
                case "md":
                    return "100px";
                case "lg":
                    return "100px";
                case "xl":
                    return "100px";
                case "xxl":
                    return "100px";
                default:
                    return "100px";
            }
        },
        mainCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 7;
                case "lg":
                    return 7;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        imageCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 6;
                case "lg":
                    return 6;
                case "xl":
                    return 6;
                case "xxl":
                    return 6;
                default:
                    return 6;
            }
        },
        textCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 12;
                case "sm":
                    return 12;
                case "md":
                    return 5;
                case "lg":
                    return 5;
                case "xl":
                    return 4;
                case "xxl":
                    return 4;
                default:
                    return 3;
            }
        },
        navCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 2;
                case "sm":
                    return "auto";
                case "md":
                    return "auto";
                case "lg":
                    return "auto";
                case "xl":
                    return "auto";
                case "xxl":
                    return "auto";
                default:
                    return "auto";
            }
        },
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        isTooTight() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return '1fr';
                case "sm":
                    return '1fr 1fr';
                case "md":
                    return '1fr 1fr';
                case "lg":
                    return '1fr 1fr 1fr 1fr';
                case "xl":
                    return '1fr 1fr 1fr 1fr';
                case "xxl":
                    return '1fr 1fr 1fr 1fr';
                default:
                    return '1fr 1fr 1fr 1fr';
            }
        },
        isXS() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return false;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
        QuadWidth() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 3;
                case "sm":
                    return 3;
                case "md":
                    return 6;
                case "lg":
                    return 6;
                case "xl":
                    return 8;
                case "xxl":
                    return 8;
                default:
                    return false;
            }
        },
        twoCols() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return 10;
                case "sm":
                    return 10;
                case "md":
                    return 5;
                case "lg":
                    return 5;
                case "xl":
                    return 4;
                case "xxl":
                    return 4;
                default:
                    return false;
            }
        },
    },
    methods: {
        gotoPage() {
            this.$router.push("/breathwork")
        },
    }
}
</script>

<style scoped>

/* Additional information follows the existing typography and theme colors. */
.seo-information-heading {
    font-size: 2em;
    font-weight: 500;
    line-height: 1.3;
}
.seo-information-section p {
    line-height: 1.8;
}
.seo-information-section p + p {
    margin-top: 1rem;
}
.seo-information-section a:not(.v-btn) {
    color: inherit;
    text-decoration: underline;
    text-underline-offset: 0.2em;
}
.seo-qualification-draft {
    margin-top: 2rem;
    padding: 1.5rem;
    border: 1px dashed currentColor;
    border-radius: 15px;
}
.seo-qualification-draft li + li {
    margin-top: 0.75rem;
}

/* Preserve the original h1 scale after correcting the document outline. */
.seo-heading-display {
    font-size: 2em;
    font-weight: 500;
}

/* Keep existing navigation text available on small screens. */
.seo-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}
</style>
